import * as actionTypes from './actionTypes';

export default function reducer(state = {originFilter: '', destinFilter: '', flightNumFilter: '', flights: [], filteredFlights: []}, action) {
    if (action.type === actionTypes.ORIGIN_FILTER_ADDED){
        // let filterOrigin = state.filteredFlights.filter((flight) => flight.depart.airport.startsWith(action.payload.filter))
        return {...state, originFilter: action.payload.filter/*filteredFlights: filterOrigin*/}
    }
    else if (action.type === actionTypes.DESTIN_FILTER_ADDED){
        // let filterDestination = state.filteredFlights.filter((flight) => flight.arrive.airport.startsWith(action.payload.filter))

        return {...state, destinFilter: action.payload.filter /*filteredFlights: filterDestination*/}
    }
    else if (action.type === actionTypes.FNUM_FILTER_ADDED){
        // let filterFlightNum = state.filteredFlights.filter((flight) => flight.flightNumber.startsWith(action.payload.filter))

        return {...state, flightNumFilter: action.payload.filter /*filteredFlights: filterFlightNum*/}
    }
    else if (action.type === actionTypes.FLIGHTS_ADDED) {
        return {...state, filteredFlights: action.payload.flights, flights: action.payload.flights}
    }
    else if (action.type === actionTypes.RESET_TRIGGERED) {
        return {...state, filteredFlights: state.flights}
    }
    else if (action.type === actionTypes.DESTINATION_OPTIONS_UPDATED) {
  return { ...state, destinationOptions: action.payload.options };
}


    return state
}


// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/reducer.js